var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89.443,
    height: 121.029,
    viewBox: "0 0 89.443 121.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 89.443,
    height: 121.029,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M57.8,10.624H9.813A4.874,4.874,0,0,0,4.769,15.3a4.874,4.874,0,0,0,5.044,4.683h.88V77.116A22.315,22.315,0,0,0,32.983,99.408h1.642A22.313,22.313,0,0,0,56.914,77.116V19.987H57.8A4.873,4.873,0,0,0,62.842,15.3a4.873,4.873,0,0,0-5.041-4.68m-7.67,66.492A15.505,15.505,0,0,1,34.625,92.625H32.983A15.512,15.512,0,0,1,17.474,77.116V19.987H50.131Z",
    transform: "translate(9.705 21.621)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 5.97,
    height: 2.692,
    transform: "translate(49.162 56.1)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 5.97,
    height: 2.701,
    transform: "translate(49.162 49.104)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 5.97,
    height: 2.695,
    transform: "translate(49.162 62.719)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M32.862,26.821c-7.029-.543-17.452-5.639-22.984.352V49.538A12.75,12.75,0,0,0,22.61,62.267h1.6A12.748,12.748,0,0,0,36.936,49.538V26.1a8.68,8.68,0,0,1-4.073.725",
    transform: "translate(20.102 49.418)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M26.373,17.107c2.021-4.41,4.434-7.375,7.105-9,.215-.134.434-.243.646-.364a19.49,19.49,0,0,0-5.138,1.2,17.353,17.353,0,0,0-5.77,3.8c-.358.34-.713.716-1.059,1.1l-.021-.061c-.492-.47-1-.947-1.533-1.445a108.515,108.515,0,0,0-9.676-7.87l-.012-.009a67.343,67.343,0,0,1,5.8,9.33,56.3,56.3,0,0,1,2.953,7.475h5.111a39.342,39.342,0,0,1,1.593-4.161",
    transform: "translate(22.213 9.083)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M16.324,10.783A3.451,3.451,0,0,0,20.2,7.76a3.53,3.53,0,0,0-2.932-4,3.46,3.46,0,0,0-3.876,3.032,3.517,3.517,0,0,0,2.932,3.988",
    transform: "translate(27.187 7.589)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M32.353,20.845A85.938,85.938,0,0,1,50.882,1.22C51.447.8,52.021.4,52.582,0A68.04,68.04,0,0,0,41.535,5.472,63.77,63.77,0,0,0,30.1,14.644c-.683.68-1.366,1.387-2.024,2.094l.006-.079c-.443-.619-.9-1.232-1.366-1.857a59.86,59.86,0,0,0-8.6-9.038l-.006,0a62.389,62.389,0,0,1,3.144,12.322,70.313,70.313,0,0,1,.461,12.268h4.656c1.9-3.351,3.888-6.547,5.979-9.506",
    transform: "translate(36.861 0.001)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M24.806,10.157a4.857,4.857,0,0,0,4.641-5.05A4.854,4.854,0,0,0,24.806.068a4.857,4.857,0,0,0-4.647,5.038,4.86,4.86,0,0,0,4.647,5.05",
    transform: "translate(41.025 0.139)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M30.6,18.53A60.378,60.378,0,0,1,33.677,6.59l-.009.006a58.165,58.165,0,0,0-8.4,8.753c-.467.6-.9,1.2-1.335,1.8l.006.082c-.646-.686-1.317-1.369-1.979-2.033A61.918,61.918,0,0,0,10.79,6.317,66.065,66.065,0,0,0,0,1.012c.546.379,1.111.771,1.657,1.178A83.855,83.855,0,0,1,19.764,21.2c1.587,2.234,3.111,4.619,4.583,7.09h5.718A64.864,64.864,0,0,1,30.6,18.53",
    transform: "translate(0 2.06)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M10.642,10.847a4.723,4.723,0,0,0,4.543-4.889A4.716,4.716,0,0,0,10.642,1.08,4.717,4.717,0,0,0,6.105,5.957a4.724,4.724,0,0,0,4.537,4.889",
    transform: "translate(12.424 2.199)",
    fill: "#5cc3d6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.69ea7eb45da501101d467da0796a06de.svg";
export { ForwardRef as ReactComponent };